export default __webpack_public_path__ + "static/media/2-4-1.3dff5490.jpg";